import { CreateControllerFn, IWixAPI } from '@wix/yoshi-flow-editor';
import { SEARCH_LIGHTBOX_TPA_PAGE_ID } from '@wix/site-search-common';
import { uoUClickOnSearchIconSrc99Evid410 } from '@wix/bi-logger-wix-code-data/v2';

const createController: CreateControllerFn = async (params) => {
  const { flowAPI, controllerConfig } = params;
  const { $w, wixCodeApi } = controllerConfig;
  return {
    pageReady: async () => {
      const searchButtons = $w('@searchButton');
      if (searchButtons.length === 0) {
        return;
      }
      const lightboxId = await getSearchModalLightboxId(wixCodeApi);

      searchButtons.onClick(async () => {
        flowAPI.bi?.report(uoUClickOnSearchIconSrc99Evid410({}));

        if (!lightboxId) {
          // eslint-disable-next-line no-console
          console.error('Search modal lightbox not found');
        } else {
          await wixCodeApi.window.openLightboxById(lightboxId, {});
        }
      });
    },
  };
};

async function getSearchModalLightboxId(
  wixCodeApi: IWixAPI,
): Promise<string | undefined> {
  const siteStructure = await wixCodeApi.site.getSiteStructure({
    includePageId: true,
  });
  return siteStructure.lightboxes.find(
    ({ tpaPageId }) => tpaPageId === SEARCH_LIGHTBOX_TPA_PAGE_ID,
  )?.id;
}

export default createController;
